import { TableVizPropVersion } from '../types/prism';
export const TABLE_CLIENT_STATE_LATEST_VERSION = TableVizPropVersion.V1;
export const initTableClientState = (vizModel) => ({
    ...vizModel.vizProps,
    columnProperties: [],
    density: null,
    orderedColumnIds: [],
    showGridSummary: null,
    showTableFooter: null,
    theme: null,
    widthState: [],
    wrapTableHeader: null,
    tableVizPropVersion: TABLE_CLIENT_STATE_LATEST_VERSION,
    __typename: 'TableVizProps',
});
//# sourceMappingURL=table-client-state-init.js.map